import React, { useEffect, useState } from 'react';
import '../companyInformation/companyForm/CompanyForm.css';
import { useNavigate } from 'react-router-dom'; 
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedRow, setSearchValue, getFromGus, setIsLoading, resetCompanyData } from '../../features/customer/companySlice';
import { getCompanyByTaxId, getCompanyByText } from '../../features/customer/companySlice';
import '../companySearch/CompanySearchInput.css';
import Test from '../test/Test';
import { setCustomerType, setNewCustomer } from '../../features/customer/customerSlice';
import { setTargetCustomerParams } from '../../features/customer/targetCustomerSlice';
import { Dialog } from '../common/dialog/Dialog';
import { LoadingSpinner } from '../common/loadingSpinner/LoadingSpinner';
import { ErrorToast } from '../common/errorToast/ErrorToast';

export const CompanySearchInput = ({showDialog,selectCode, setShowDialog,setSelectCode, setIsCompanyFound, isCompanyFound}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { companies, selectedRow, searchValue } = useSelector((state) => state.company);
  const [inputValue, setInputValue] = useState('');
  const [openSearchList, setOpenSearchList] = useState(false);
  const [hideButton, setHideButton] = useState(false);
  const complaintTypeName = useSelector((state)=>state.complaint.complaintType.name);
  const isLoading = useSelector((state)=>state.company.isLoading);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const [searchAgain,setSearchAgain] = useState(false);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    dispatch(setSearchValue(event.target.value));
  
    if (!event.target.value) {
      setOpenSearchList(false);
      setHideButton(false);
    }
    if (event.target.value === '' && searchAgain) {
      setSearchAgain(false);
      dispatch(resetCompanyData());
    }
  };
  useEffect(() => {
    function handlePageChange() {
        setCurrentPage(window.location.pathname);
    }
    window.addEventListener("popstate", handlePageChange);
    return () => {
        window.removeEventListener("popstate", handlePageChange);
    };
}, [currentPage]);

const handleButtonClick = async () => {
  dispatch(setIsLoading(true));

  try {
    const action = await dispatch(getCompanyByTaxId({ taxId: inputValue }));
    dispatch(setIsLoading(false));

    const companyFound = action.payload && action.payload.length > 0;
    setIsCompanyFound(companyFound);

    if (!companyFound) {
      const gusAction = await dispatch(getFromGus({ taxId: inputValue }));
      const gusCompanyFound = gusAction.payload && gusAction.payload.length > 0;
      setIsCompanyFound(gusCompanyFound);

      if (!gusCompanyFound) {
        setIsError(true);
        setErrorMsg('Nie znaleziono firmy o podanym numerze NIP');
        setTimeout(() => {
          setIsError(false);
        }, 8000);
      } else {
        setIsError(false);
      }
    }

    if (inputValue === '') {
      setOpenSearchList(false);
      setHideButton(false);
      setIsError(true);
      setErrorMsg('Pole nie może być puste, wpisz numer NIP, który chcesz wyszukać');
      setTimeout(() => {
        setIsError(false);
      }, 8000);
    } else if (/[^0-9\-]/.test(inputValue) || (inputValue.length !== 10 && inputValue.length !== 13)) {
      setIsError(true);
      setErrorMsg('Wyszukiwany numer NIP jest niepoprawny');
      setTimeout(() => {
        setIsError(false);
      }, 8000);
    } else {
      setOpenSearchList(true);
      setHideButton(true);
      setIsError(false);
    }
  } catch (error) {
    console.error('Wystąpił błąd podczas wyszukiwania firmy:', error);
    dispatch(setIsLoading(false));
  }
};
  const handleRowClick = (item) => {
    dispatch(setSelectedRow(item.id));
    if(item.id === 0){
      dispatch(setNewCustomer(true));
    }
    setInputValue(item.companyName);
    dispatch(setSearchValue(''));
    setOpenSearchList(false);
    setHideButton(true);
    setSearchAgain(true); 
    dispatch(setTargetCustomerParams({id:item.id}))
    setSelectCode(item.code);
    const x = item.code.startsWith('F_') && complaintTypeName === 'Warranty' || item.code.startsWith('F_') && complaintTypeName === 'DeliveryMismatch' || item.code.startsWith('F_') && complaintTypeName === 'TransportDamage';
    const y = !isCompanyFound && complaintTypeName === 'Warranty' || !isCompanyFound && complaintTypeName === 'DeliveryMismatch' || !isCompanyFound && complaintTypeName === 'TransportDamage';
    if(x || y){
      setShowDialog(true)
    }
  };

  const handleKeyDown = (event) => {
    if (event.keyCode) {
      setOpenSearchList(false);
      setHideButton(false);
    }
  };

  const handleBackClick = () =>{
    setCurrentPage('customers');
    navigate('/customers'); 
  }
  return (
    <div>
    <div className='nip-search-container'>
    <div className='nip-label-container'>
          <label className='nip-label-text'>Nip</label>
    </div>
      <input type="text" className='nip-input' value={inputValue} onChange={handleInputChange} onFocus={handleKeyDown}/>
      <div className='nip-search-button'>
      {!openSearchList &&  
         <a className='nip-button-search-text' onClick={handleButtonClick}>Pobierz dane</a>
        }
      </div> 
      <div>
      {isLoading === true && <LoadingSpinner/>}
      {openSearchList && companies && companies.length > 0 && (
        <div className='companies-list' style={{width:"100%", wordBreak:'break-all'}}> 
        <table className="demTable">
                <thead>
                  <tr>
                    <th className='company-list-row'>Nazwa: </th>
                    <th className='company-list-row'>Akronim: </th>
                    <th className='company-list-row'>Ulica: </th>
                    <th className='company-list-row'>Miejscowość: </th>
                  </tr>
                </thead>
          </table>
          {companies.map((item) => {
  if (companies.filter(c => c.taxId === item.taxId).length > 1) {
    if (item.code.includes('_00')) {
      return (
        <div key={item.id} className={`company-list-row ${selectedRow && selectedRow.id === item.id ? 'selected' : ''}`} onClick={() => handleRowClick(item)}>
          <table className="demTable" style={{ border: '1px solid #D5D5D5' }}>
            <tbody>
              <tr>
                <td className='company-list-row'>{item.companyName}</td>
                <td className='company-list-row'>{item.code}</td>
                <td className='company-list-row'>{item.fullAddress}</td>
                <td className='company-list-row'>{item.city}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    } else {
      return (
        <div key={item.id} className={`company-list-row ${selectedRow && selectedRow.id === item.id ? 'selected' : ''}`} onClick={() => handleRowClick(item)}>
          <table className="demTable" style={{ border: '1px solid #D5D5D5' }}>
            <tbody>
              <tr>
                <td className='company-list-row'>{item.companyName}</td>
                <td className='company-list-row'>{item.code}</td>
                <td className='company-list-row'>{item.fullAddress}</td>
                <td className='company-list-row'>{item.city}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
  })}
        </div>
      )}
      </div>
      {openSearchList && inputValue === '' && <div></div>}
    </div>
      {isError && <ErrorToast message={errorMsg}/>}
      {!selectedRow &&
      <div className="company-search-btn-container">
          <button className="company-search-btn-prev" onClick={handleBackClick}><p>Wróć</p></button>
          <button className="company-search-btn-next" disabled><p>Dalej</p></button>
        </div>}
    </div>
    
  );
};